module.exports = __webpack_public_path__ + "images/dashboard-progress@2x-40615f8b24e75a3d9e0e6b2a51d8ae87.png";